import classnames from 'classnames/bind'
import React from 'react'

import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleImageTextProps {
  className?: string
  subtitle?: RichTextBlock[]
  text?: RichTextBlock[]
  image?: ImageWithPlaceholderProps
  reversed?: boolean
}

function ArticleImageText({
  className,
  subtitle,
  text,
  image,
  reversed,
}: ArticleImageTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const subtitleStyle = useStyle({ textPreset: 'title-content' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })

  return (
    <div className={cx(css.ArticleImageText, className, { reversed })}>
      <div className={gridStyle}>
        {image && (
          <Ratio className={css.image} ratio={660 / 778}>
            {(cn) => (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="cover"
                {...image}
              />
            )}
          </Ratio>
        )}
        <div className={css.texts}>
          {subtitle && (
            <RichText
              className={cx(css.subtitle, subtitleStyle)}
              render={subtitle}
            />
          )}
          {text && text?.length > 0 && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
        </div>
      </div>
    </div>
  )
}

ArticleImageText.defaultProps = {}

export default ArticleImageText
